import { IDeepCopy } from "@common/interfaces/i-deep-copy";
import { FilterDef } from '@common/data-models/navigation/filter-def';
import { ViewStateTypes } from "@suite/common/enums/viewstate-types";
import { SearchResults } from "@suite/common/data-models/search-results/search-results";
import { TopicViewStateRecord } from "@suite/common/data-models/records/topic-viewstate-record";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names"

export class ViewStateFilter implements IDeepCopy<ViewStateFilter> {
    public filters: Array<FilterDef> = [];
    public relationshipFilters: Array<FilterDef> = [];
    public map: { [id: string]: FilterDef } = {};
    public groups: Array<FilterDef> = [];

    private _allFilters: Array<FilterDef> = [];

    private onChange: (value: any, prev: any) => any;
    public set OnChange(f: (v: any, p: any) => any) {
        this.onChange = f;
        for (let f of this.filters) {
            f.OnChange = (v, p) => {
                this.onChange(v, p);
            }
        }
        for (let f of this.relationshipFilters) {
            f.OnChange = (v, p) => {
                this.onChange(v, p);
            }
        }
    }

    constructor() { }

    public push(f: FilterDef) {
        if (f.IsRelationship) {
            this.relationshipFilters.push(f);
        } else {
            this.filters.push(f);
        }
        this._allFilters.push(f);
        if (!f.NotUsed) {
            if (f.IsRequired) {
                this.requiredFilters.push(f);
            } else {
                this.optionalFilters.push(f);
            }
        }
        if (this.OnChange) {
            f.OnChange = (v, p) => {
                this.OnChange(v, p);
            }
        }
        this.map[f.ID] = f;
    }

    public getFilters(viewStateType: ViewStateTypes): Array<FilterDef> {
        if (viewStateType == ViewStateTypes.TOPIC || viewStateType == ViewStateTypes.ASSIGNMENT) {
            let vsRec = <TopicViewStateRecord>(SearchResults.appService.viewStateService.NavigationViewStateRecord);

            if (vsRec && (
                (vsRec.viewStateLayout && vsRec.viewStateLayout.Value !== 'map')
                ||
                (vsRec.viewStateType == ViewStateTypes.ASSIGNMENT)
            )) {
                return this._allFilters.filter(f => f.ID !== PSTFieldNames.PSTTeamLocation);
            }
            return this._allFilters;
        }

        return this.filters.filter(f => f.ID !== PSTFieldNames.PSTTeamLocation);
    }

    public requiredFilters: Array<FilterDef> = [];

    public optionalFilters: Array<FilterDef> = [];

    public get allFilters(): Array<FilterDef> {
        return [...this._allFilters];
    }

    public toJSON() {
        return JSON.stringify(this.map);
    }

    public deepCopy(): ViewStateFilter {
        let ret = new ViewStateFilter();
        for (let f of this.filters) {
            ret.push(f.deepCopy());
        }
        for (let g of this.groups) {
            ret.groups.push(g.deepCopy());
        }
        for (let rel of this.relationshipFilters) {
            ret.push(rel.deepCopy());
        }
        return ret;
    }

    public onFilterStateChange(fromRequired: boolean) {
        if (fromRequired) {
            let ids: Array<string> = this.requiredFilters.map((f) => f.ID);
            this.requiredFilters.forEach((f) => {
                this.map[f.ID].IsRequired = true;
                this.map[f.ID].IsOptional = false;
                this.map[f.ID].NotUsed = false;
            });
            this.allFilters.forEach((f) => {
                if (ids.indexOf(f.ID) == -1) {
                    f.IsRequired = false;
                    if (!f.IsOptional) f.NotUsed = true;
                }
            });
        } else {
            let ids: Array<string> = this.optionalFilters.map((f) => f.ID);
            this.optionalFilters.forEach((f) => {
                this.map[f.ID].IsRequired = false;
                this.map[f.ID].IsOptional = true;
                this.map[f.ID].NotUsed = false;
            });
            this.allFilters.forEach((f) => {
                if (ids.indexOf(f.ID) == -1) {
                    f.IsOptional = false;
                    if (!f.IsRequired) f.NotUsed = true;
                }
            });
        }
    }

    public initialize(viewStateType: ViewStateTypes) {
        this.requiredFilters = this.getFilters(viewStateType).filter((item) => {
            if (item.IsRequired && !item.NotUsed) {
                return true;
            }
            return false;
        });
        this.optionalFilters = this.getFilters(viewStateType).filter((item) => {
            if (!item.IsRequired && !item.NotUsed) {
                return true;
            }
            return false;
        });
    }
}
